import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { fullbleedHeaderLinkLabel } from '../../../../constants/seasonal';
import { LocationState } from '../../../../types';
import HeaderTitle, { HeaderTitleProps } from './HeaderTitle';

interface ExperimentHomepageBannerCTAHeaderTitleProps extends HeaderTitleProps {
    location: LocationState;
}
const ExperimentHomepageBannerCTAHeaderTitle = ({
    header,
    location,
    ...rest
}: ExperimentHomepageBannerCTAHeaderTitleProps) => {
    let linkLabel = fullbleedHeaderLinkLabel;
    if (location?.isOnline) {
        linkLabel = gettext('Explore online events');
    } else if (location?.isUsingCurrentLocation) {
        linkLabel = gettext('Explore your location events');
    } else if (location?.currentPlace) {
        linkLabel = gettext('Explore %(location)s events', {
            location: location.currentPlace,
        });
    }

    const headerProps = {
        ...header,
        customLinkLabel: linkLabel,
    };

    return <HeaderTitle header={headerProps} {...rest} />;
};
export default ExperimentHomepageBannerCTAHeaderTitle;
